function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="21" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function modifyBtnTickets() {
  const ticketBtn = $('.ticket');
  ticketBtn.text('Tickets');
  ticketBtn.addClass('button');
  ticketBtn.attr('aria-label', 'Click here to buy tickets');
  ticketBtn.attr('aria-hidden', 'true');
}

// change Directions text button
function changeDirectionsText() {
  const directionsText = window.innerWidth > 768 ? 'Directions' : 'Go!';
  $('.standAloneDirections').text(directionsText);
}

let currentViewport = '';

function hideContactHeader() {
  const newViewport = window.innerWidth <= 990 ? 'small' : 'large';
  const showingNavLength = $('.showingNav').length;
  const contactHeader = $('#contactHeader');

  if (newViewport !== currentViewport) {
    if (newViewport === 'large') {
      // Si es un viewport grande, mostrar #contactHeader solo si showingNavLength > 4
      contactHeader.css(
        'display',
        showingNavLength < 4 ? 'inline-flex' : 'none'
      );
    } else {
      // Si es un viewport pequeño, ocultar #contactHeader
      contactHeader.css('display', 'none');
    }

    currentViewport = newViewport;
  }

  return newViewport === 'small';
}

function modifyHeaderWidth() {
  const linksLength = $('.showingNav').length;
  if (linksLength >= 5) {
    $('body').addClass('header-wide');
  }
}


// set the background image of the feature item to no_image_available.jpg if the image is not available
function imageUnavailable() {
  // get all the feature items. For each item, get the value of data-background-image and print it by console.log
  const featureItems = document.querySelectorAll(".featureItem");
  featureItems.forEach((item) => {
    const backgroundImage = item
      .querySelector(".featureItemImage")
      .getAttribute("data-background-image");
    // if backgroundImage includes 'no_image_available', change the background image url of the item to ${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`
    if (backgroundImage.includes("no_image_available")) {
      item.querySelector(
        ".featureItemImage"
      ).style.backgroundImage = `url(${FULLCLIENTTHEMEPATH}images/no_image_available.jpg)`;
    }
  });
}

$(document).ready(() => {
  $('.generalmessage').prependTo('header');

  modifyBtnNavToggle();
  modifyBtnTickets();
  const contactHref = $('.footer-navigation__item a[href*="contact"]').attr(
    'href'
  );
  $('#contactHeader').attr('href', contactHref);

  // add home link to the footer logo
  const homeURL = $('.header-logo').attr('href');
  $('.footer-logo').attr('href', homeURL);
});

$(window).load(() => {
  // remove contact button from header
  hideContactHeader();
  modifyHeaderWidth();
  setTimeout(() => {
    $('.navbar').css('opacity', '1');
  }, 500);
});
$(window).resize(() => {
  // ---
  hideContactHeader();
});

if (window.location.pathname === '/') {
  // insert direction buttons on map-card
  $(document).ready(() => {
    changeDirectionsText();
    // append directions button to map-card
    $('.standAloneDirections').appendTo('.map-card__description--button');
    $('.directionsPin').remove();

    const contactHref = $('.footer-navigation__item a[href*="contact"]').attr(
      'href'
    );

    $('#contactUs').attr('href', contactHref);

    // wrap .map-card in a anchor tag
    const mapCard = $('.map-card');
    mapCard.wrap(
      `<a target="_blank" aria-description="click to open map location" href="https://www.google.com/maps?q=Charles+F.+Dodge+City+Center+Pembroke+Pines,+City+Center+Way,+Pembroke+Pines,+FL"></a>`
    );
    imageUnavailable();
  });

  $(window).load(() => {
    // remove events section if empty
    if ($('.events-section').children().length < 1) {
      $('.events-section').remove();
    }
  });

  $(window).resize(() => {
    // ---
    changeDirectionsText();
  });
}
